module.exports = __webpack_public_path__ + "static/img/spec1.03bd2eb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spec1.jpeg
// module id = JWx2
// module chunks = 1